import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appCustomCellTemplate]',
})
export class CustomCellTemplateDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
